import { createFileRoute } from '@tanstack/react-router';
import { Card } from '@/ui/primitives';
import { PageShell, Stack } from '@/ui/layout';
import { useConfig, useHealth } from '@/modules/config/api';
import { ConfigForm } from '@/modules/config/components/ConfigForm';
import { HealthCheckPanel } from '@/modules/config/components/HealthCheckPanel';
import { HealthStats } from '@/modules/config/components/HealthStats';
import { MaintenancePanel } from '@/modules/config/components/MaintenancePanel';

export const Route = createFileRoute('/_authed/config')({
  component: ConfigPage,
});

function ConfigPage() {
  const { data: config, isLoading: cfgLoading } = useConfig();
  const { data: health, isLoading: healthLoading } = useHealth();

  return (
    <PageShell
      eyebrow="Admin"
      title="Configurações"
      lead="Modelo padrão, heartbeat, saúde do sistema e manutenção."
    >
      <Stack gap="lg">
        <HealthStats health={health} isLoading={healthLoading} />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {cfgLoading || !config ? (
            <Card padding="lg">
              <p className="text-sm text-text-muted">Carregando configuração…</p>
            </Card>
          ) : (
            <ConfigForm config={config} />
          )}

          <Stack gap="md">
            <HealthCheckPanel />
            <MaintenancePanel />
          </Stack>
        </div>
      </Stack>
    </PageShell>
  );
}
